<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M3 3h18v2H3V3m0 4h12v2H3V7m0 4h18v2H3v-2m0 4h12v2H3v-2m0 4h18v2H3v-2z"/>
    </svg>
</template>

<script>
export default {
    name: 'FormatAlignLeftIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
